import { Route } from '@angular/router'
import { Permissions } from '../../access/shared/authorization/permissions'
import { BesoinDispatchComponentRouting } from './besoin/besoin-dispatch/besoin-dispatch-routing'
import { BesoinEditComponentRouting } from './besoin/besoin-edit/besoin-edit-routing'
import { BesoinListRouting } from './besoin/besoin-list/besoin-list-routing'
import { CommandeLingeriesEditRouting } from './commande-lingeries/commande-lingeries-edit/commande-lingeries-edit-routing'
import { InventaireEditRouting } from './commande-lingeries/inventaire-edit/inventaire-edit-routing'
import { CommandeListRouting } from './commande-list/commande-list-routing'
import { CommandeConfirmRouting } from './commande/commande-confirm/commande-confirm-routing'
import { CommandeEditRouting } from './commande/commande-edit/commande-edit-routing'
import { LingeHebergementComponent } from './linge-hebergement.component'

export const LingeHebergementRouting: Route = {
  path: 'linge-hebergement', component: LingeHebergementComponent,
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'prefix' },
    CommandeListRouting,
    CommandeEditRouting,
    CommandeConfirmRouting,
    CommandeLingeriesEditRouting,
    InventaireEditRouting,
    BesoinEditComponentRouting,
    BesoinDispatchComponentRouting,
    BesoinListRouting
  ],
  data: {
    breadcrumb: "Gestion linge d'hébergement",
    'role': [
      Permissions.ROLE_HEBERGEMENT,
    ],
  }
}
